import { DynamicBlock } from "@components/block";
import { PostGrid } from "@components/grid";
import { ShadeHeader } from "@components/header";
import { useWindowSize } from '@components/window-size-provider';
import { Pagination } from "@customTypes/index";
import { getWordpressVars } from "@lib/wordpressVars";
import { useGetPostsQuery } from "@mwServices/Post";
import { Col, Layout, Row, Spin } from "antd";
import { useState, useEffect } from "react";
import { useGetHeaderAdsQuery } from "@mwServices/Ads";
import { HeaderAd } from "@components/header-ad";

interface ArchiveProps {
    objectId?: number;
}

const defaultProps: ArchiveProps = {};

const Archive = () => {
    const { ID, title, image, taxonomy, ads, color } = getWordpressVars();
    const { isLargeScreen } = useWindowSize();

    const [pagination, setPagination] = useState<Pagination>({
        simple: true,
        type: 'Numbers',
        current_page: 1,
        per_page: 20,
    })

    const {
        isLoading,
        data,
    } = useGetPostsQuery({
        terms: ID,
        taxonomies: taxonomy,
        perPage: pagination.per_page,
        curPage: pagination.current_page,
        parts: [
            'ID', 'title', 'description', 'link', 'image',
        ],
    });

    const headerAdsQuery = useGetHeaderAdsQuery({ID});
    const [desktopHeaderAd, setDesktopHeaderAd] = useState<any>();
    const [mobileHeaderAd, setMobileHeaderAd] = useState<any>();
    useEffect(() => {
        if (headerAdsQuery.data) {
            headerAdsQuery.data.forEach((ad) => {
                if (ad.isMobile) {
                    setMobileHeaderAd(ad);
                } else {
                    setDesktopHeaderAd(ad);
                }
            });
        }
    }, [headerAdsQuery.data]);

    const handleOnChange = (current: number, perPage: number) => {

        setPagination({
            ...data?.pagination,
            current_page: current,
            per_page: perPage,
        });
    }

    return (
        <Layout className="post-archive">
            <Row className={`mar-bot-30`}>
                <Col span={24}>
                </Col>
            </Row>
            <Row justify={`center`} className={`mar-bot-30`}>
                <Col lg={22} xs={23}>
                    <Row
                        className={isLargeScreen ? 'grid-auto-350' : ''}
                        gutter={[30, 30]}
                    >
                        <Col className={`border-r-1-light-grey`}>
                            <Spin size="large" spinning={isLoading}>
                                <ShadeHeader
                                    className={`covr-single-header archive mar-bot-30`}
                                    title={title}
                                    parallax={false}
                                    focalPoint={image?.focalPoint}
                                    imgSrc={image?.src}
                                    backgroundColor={color}
                                />

                                {(!isLargeScreen && mobileHeaderAd) ?
                                    <HeaderAd
                                        campaignUrl={mobileHeaderAd.campaignUrl}
                                        adId={mobileHeaderAd.adId}
                                        imageUrl={mobileHeaderAd.imageUrl}
                                        style={{marginBottom: '25px'}}
                                    />
                                    : (isLargeScreen && desktopHeaderAd) ?
                                        <HeaderAd
                                            campaignUrl={desktopHeaderAd.campaignUrl}
                                            adId={desktopHeaderAd.adId}
                                            imageUrl={desktopHeaderAd.imageUrl}
                                            style={{marginBottom: '40px'}}
                                        />
                                        : <hr className={`border-b-1`} />
                                }

                                <Row className="minHeight">
                                    <Col span={24}>
                                        {data?.results
                                            && <PostGrid
                                                data={data.results}
                                                perRow={2}
                                                cta={{ flip: 'start', type: 'Flag' }}
                                                showFields={['title', 'description', 'category']}
                                                onPaginationChange={handleOnChange}
                                                pagination={{
                                                    ...data?.pagination,
                                                    type: 'Numbers'
                                                }}
                                            />}
                                    </Col>
                                </Row>
                            </Spin>
                        </Col>
                        <Col>
                            {ads && <DynamicBlock blocks={ads} />}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Layout>
    );
};

Archive.defaultProps = defaultProps;

export default Archive;
